<script lang="ts">
  export let text: string;
</script>

<div class="mt-3 px-4">
  {text}
</div>